import React, { FC, useEffect, useState } from 'react';
import '@rbx/ui';
import { useTranslation } from '@rbx/intl';
import { TestId } from '@modules/utilities/constants/testConstants';
import useStreamingIndicatorStyles from './StreamingIndicator.styles';

type StreamingIndicatorProps = {
  maxNumDots: number;
  className?: string;
};
const StreamingIndicator: FC<React.PropsWithChildren<StreamingIndicatorProps>> = ({
  maxNumDots,
  className,
}) => {
  const { translate } = useTranslation();
  const {
    classes: { container, dot },
    cx,
  } = useStreamingIndicatorStyles();
  const [numDots, setNumDots] = useState<number>(0);
  useEffect(() => {
    const interval = setInterval(() => {
      setNumDots((num) => (num + 1) % (maxNumDots + 1));
    }, 300);
    return () => clearInterval(interval);
  }, [maxNumDots]);
  return (
    <div
      aria-label={translate('Label.StreamingIndicator')}
      data-testid={TestId.StreamingIndicator}
      className={cx(container, className)}>
      {new Array(maxNumDots).fill('.').map((str: string, i: number) => (
        <span
          key={str + String(i)}
          className={dot}
          style={{
            opacity: i + 1 <= numDots ? 100 : 0,
          }}
        />
      ))}
    </div>
  );
};

export default StreamingIndicator;
